import { render } from "./EntranceExitCreate.vue?vue&type=template&id=b69b46c2"
import script from "./EntranceExitCreate.vue?vue&type=script&lang=js"
export * from "./EntranceExitCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__